import "./CardGrupoFamiliaPending2.css";
import IconVinculo from "../../../../assets/images/generico/GrupoFamiliarIcon";
import camelize from "../../../../../global/utils/camelize";
import { showModal } from "../../../../context/Actions/modal/modal";
import { useContext } from "react";
import { PortalContext } from "../../../../context/Provider";
import { GlobalContext } from "../../../../../global/context/Provider";

const CardGrupoFamiliaPending2 = ({
  pariente,
  idpaciente2_desc,
  idFamiliar,
  idpaciente2,
}) => {
  const { modalDispatch } = useContext(PortalContext);

  // Cambio de contexto
  const { authState, authDispatch } = useContext(GlobalContext);

  const handleClick = () => {
    showModal(
      "Perfil/ModalGrupoFamiliar/ModalGrupoFamiliar",
      {
        nombre: camelize(idpaciente2_desc),
        idpaciente1: idpaciente2,
        type: "PUT",
        idFamiliar,
      },
      [],
      "centro",
      true
    )(modalDispatch);
  };

  const modalAutorizarConClave = () => {
    showModal(
      "Perfil/ModalAutorizarFamiliar/ModalAutorizarFamiliar",
      {
        nombre: camelize(idpaciente2_desc),
        idFamiliar: idFamiliar,
      },
      [],
      "centro",
      true
    )(modalDispatch);
  };

  return (
    <div className="ptur-grupoFamiliarPending2-container">
      <div className="ptur-grupoFamiliarPending-top flexPending2 bgcG-danger">
        <div>
          <IconVinculo />
          <span className="rb18m">{pariente}</span>
        </div>
        <button
          className="ptur-grupoFamiliar-botonDesvincular rb16m c-white"
          onClick={handleClick}
        >
          Desvincular
        </button>
      </div>
      <div className="ptur-grupoFamiliarPending-body bodyHeight1">
        <span className="rb18b"> {camelize(idpaciente2_desc)}</span>
      </div>
      <div className="line"></div>
      <div className="ptur-grupoFamiliarPending-body bodyHeight">
        <div className="ptur-grupoFamiliarPending-circle">
          <div className="ptur-grupoFamiliarPending-point"></div>
          <div className="ptur-grupoFamiliarPending-point"></div>
          <div className="ptur-grupoFamiliarPending-point"></div>
        </div>
        <h1 className="ptur-grupoFamiliarPending-textDanger rb16m">
          {" "}
          Debe aceptar su autorización
        </h1>
      </div>
      <div className="ptur-grupoFamiliarPending-footer flex-column">
        {/* <button className="ptur-grupoFamiliar-buttonNew rb16m">
          {" "}
          Reenviar autorización a su email
        </button> */}
        <button
          className="ptur-grupoFamiliar-buttonNew rb16m"
          onClick={modalAutorizarConClave}
        >
          Autorizar a familiar con su clave de portal
        </button>
      </div>
    </div>
  );
};

export default CardGrupoFamiliaPending2;
